import React, { useState, useEffect } from 'react';
import { AgendaStreamingContext } from '../../common/AgendaStreamingContextProvider';
import { getMatchStreamingProps, getStreamingId } from '../../data/streaming/streamingUtils';
import { iconCategoryCssClass } from '../../data/utils/iconCategoryCssClass';
import { iconSportCssClass } from '../../data/utils/iconSportCssClass';
import { StreamingContext } from '../Live';



function AgendaStreamingSport(props) {
    const agendaStreamingContext = React.useContext(AgendaStreamingContext);
    const streamingContext = React.useContext(StreamingContext);
    const [collapsed, setCollapsed] = useState(false);

    const firstTournament = props.tournamentsById && Object.values(props.tournamentsById)[0];
    const icoSport = firstTournament && iconSportCssClass(firstTournament.sportRef,firstTournament.iconClassSport);

    function handleCollapse() {
        setCollapsed(!collapsed);
    }

    
    
    return (
        <>
            <div className="list-element sport-collapse" onClick={handleCollapse} >
               <div className={"prematch-sport-img big "+ icoSport}></div>
               <span className="list-element-text list-heading push-left">{props.sportDesc}</span>
               <span className={"arrow " + (collapsed ? 'arrow-expand' : 'arrow-collapse')}></span>
            </div>
            {!collapsed &&
                <>
                    {Object.values(props.tournamentsById).map((tournament, tIndex) => {
                        const icoCategory = iconCategoryCssClass(tournament.sportRef, tournament.categoryRef, tournament.iconClassCountry)
                        return ( tournament.hasMatches && 
                            <React.Fragment key={tournament.tournamentId}>
                                <div className="heading">
                                    <div className={"prematch-sport-img big push-left " +icoSport}></div>
                                    <div className="push-left">
                                        <div className={"prematch-sport-img big " +icoCategory}></div>
                                        <span className="list-element-text">{tournament.tournamentDesc}</span>
                                    </div>
                                </div>
                                {Object.values(tournament.matchesById).map(function(match,mIndex){

                                                const streamingMap = getMatchStreamingProps(match);
                                                const streaming = streamingMap && streamingMap[match.id];
                                                const streamingId = getStreamingId(streaming);

                                                function toggleStreaming() {
                                                    if(isStreamingOpened()) {
                                                        closeStreaming();
                                                        agendaStreamingContext.setCurrentMatch(null);
                                                    } else {
                                                        agendaStreamingContext.setCurrentMatch(match);
                                                        streamingContext.toggleStreamingId(streaming,streamingId,match.id);
                                                    }
                                                }
                                            
                                                function isStreamingOpened(){
                                                    return streamingContext.streamingId===streamingId;
                                                }
                                            
                                                function closeStreaming(){
                                                    streamingContext.toggleStreamingId(null,null,null);
                                                }
                                                
                                                return (!match.strOver && 
                                                    <React.Fragment key={match.matchId}>
                                                        <div className="calendar-row">
                                                            <div className="calendar-row-time">{match.date.formatted}</div>
                                                            <div className="calendar-row-match">
                                                                <span>{match.team1}</span>
                                                                <span>{match.team2}</span>
                                                            </div>
                                                            <div className="calendar-row-category">
                                                            {match.str?
                                                                    <div className="live-tv-streaming-icon" onClick={toggleStreaming} ></div>
                                                                :
                                                                match.strOver?
                                                                <p>Terminato</p>
                                                                :
                                                                <p>Non iniziato</p>
                                                                }
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                )
                                })}
                             </React.Fragment>
                            );
                        })
                    }
                </>
            }
        </>
    );
}

export default AgendaStreamingSport;